// src/app/core/loading/loader-router.service.ts
import { Injectable, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable({ providedIn: 'root' })
export class LoaderRouterService {
  private router = inject(Router);
  private loader = inject(LoaderService);

  constructor() {

    console.log(this.router.events);


    this.router.events.pipe(
      filter(e => e instanceof NavigationStart)
    ).subscribe(() => this.loader.setVisible(true));

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError)
    ).subscribe(() => this.loader.setVisible(false));
  }
}
